import { Directive } from "@angular/core";

@Directive({
    selector: '[t4ListItem]',
    standalone: false
})
  export class ListItemDirective {}
